import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PreviewMode } from '@shared/models/enums/preview-mode.enum';

@Component({
  selector: 'app-preview-header',
  imports: [TranslateModule],
  templateUrl: './preview-header.component.html',
  styleUrl: './preview-header.component.scss',
})
export class PreviewHeaderComponent {
  @Input() previewMode: PreviewMode = PreviewMode.FreeFlow;

  readonly PreviewMode = PreviewMode;
}
